export default __webpack_public_path__ + "static/media/guest.5ebe0f73.png";